
const stateRadius = 30;

export { stateRadius }; 